import { render, staticRenderFns } from "./RelatorioTaxaFundoGarantidor.vue?vue&type=template&id=566a167f"
import script from "./RelatorioTaxaFundoGarantidor.vue?vue&type=script&lang=js"
export * from "./RelatorioTaxaFundoGarantidor.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTaxaFundoGarantidor.vue?vue&type=style&index=0&id=566a167f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports